import axios from 'axios'
import {
  getAccessToken,
  setAccessToken,
  getRefreshToken,
  clearTokens
} from '@/utils/token'
import config from '@/config.json'

// 建立 axios 實例
const api = axios.create({
  baseURL: config.apiBaseUrl
})

// ----- Request interceptor -----
api.interceptors.request.use(config => {
  const token = getAccessToken()
  if (token) {
    config.headers = config.headers || {}
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// ----- Refresh Queue -----
let isRefreshing = false
let failedQueue = []

function processQueue(error, token = null) {
  failedQueue.forEach(prom => {
    if (error) prom.reject(error)
    else prom.resolve(token)
  })
  failedQueue = []
}

// ----- Response Interceptor -----
api.interceptors.response.use(
  res => res,
  async err => {
    const originalRequest = err.config

    if (!err.response) return Promise.reject(err)

    // 若不是 401 或已重試過 → 拒絕
    if (err.response.status !== 401 || originalRequest._retry) {
      return Promise.reject(err)
    }

    originalRequest._retry = true

    const refresh = getRefreshToken()
    if (!refresh) {
      clearTokens()
      window.location.href = '/login'
      return Promise.reject(err)
    }

    // --- 若目前正在 refresh → queue 起來 ---
    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject })
      })
        .then(token => {
          originalRequest.headers.Authorization = `Bearer ${token}`
          return api(originalRequest)
        })
        .catch(Promise.reject)
    }

    // --- 開始 refresh ---
    isRefreshing = true

    try {
      const response = await axios.post(
        `${config.apiBaseUrl}/api/annotations/token/refresh`,
        { refresh }
      )

      const newToken = response.data.access
      setAccessToken(newToken)

      isRefreshing = false
      processQueue(null, newToken)

      originalRequest.headers.Authorization = `Bearer ${newToken}`
      return api(originalRequest)   // ⭐⭐ 這行會正確 retry 第一個 request

    } catch (refreshError) {

      isRefreshing = false
      processQueue(refreshError, null)

      clearTokens()
      window.location.href = '/login'
      return Promise.reject(refreshError)
    }
  }
)

export default api
